<div class="private-layout">
  <!--  <app-sidebar (toggle)="onSidebarToggle($event)"></app-sidebar>-->

  @if (showSideNav) {
    <div class="sidebar-container">
      <app-sidebar-new (toggle)="onSidebarToggle($event)"></app-sidebar-new>
      <app-header [ngStyle]="{ 'margin-left.px': sidebarWidth }"></app-header>
      <div class="content"
           [ngClass]="{'full_page': showContentWithoutPadding}"
           [ngStyle]="{ 'margin-left.px': sidebarWidth }">
        <app-progress-loader></app-progress-loader>

        @if (hasPermission) {
          <router-outlet></router-outlet>
        } @else {
          <app-no-access></app-no-access>
        }

      </div>
    </div>
  } @else {
    <div class="content">
      <app-progress-loader></app-progress-loader>
      @if (hasPermission) {
        <router-outlet></router-outlet>
      } @else {
        <app-no-access></app-no-access>
      }
    </div>
  }
</div>
